/* unplugin-vue-components disabled */import { render } from "./Banner.vue?vue&type=template&id=6748b308"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=6748b308&lang=scss"

import exportComponent from "E:\\普通网页项目\\奇力士官网新版\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__